document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     TOYVIX FAST MODEL SEARCH V3
     =========================================================

     普通搜索：
     Supergirl
     Female Figure
     Soosootoys

     → 使用 Shopify 原生搜索


     型号搜索：
     SST073
     SST-073
     SST 073
     MS016
     M-S016
     SK003B

     → 使用 Toyvix 自定义无符号搜索


     优化：
     1. 商品索引缓存 15 分钟
     2. 第二次型号搜索直接从缓存搜索
     3. 后续索引页尽量使用 Section Rendering API
     4. 不再每次下载 3 个完整 Shopify 页面
  ========================================================= */


  /* =========================================================
     CONFIG
  ========================================================= */

  var CACHE_KEY =
    'toyvix_product_search_index_v3';

  var CACHE_TIME_KEY =
    'toyvix_product_search_index_time_v3';

  var SECTION_ID_KEY =
    'toyvix_search_section_id_v3';

  /*
   * 15 minutes
   */

  var CACHE_TTL =
    15 * 60 * 1000;



  /* =========================================================
     ESC KEY
  ========================================================= */

  document
    .querySelectorAll(
      'input[type="search"][name="q"]'
    )
    .forEach(function (input) {

      input.addEventListener(
        'keydown',
        function (event) {

          if (event.key === 'Escape') {

            input.value = '';
            input.blur();

          }

        }
      );

    });



  /* =========================================================
     ONLY SEARCH PAGE
  ========================================================= */

  var pathname =
    window.location.pathname;


  if (
    pathname !== '/search' &&
    !pathname.endsWith('/search')
  ) {

    return;

  }



  /* =========================================================
     GET QUERY
  ========================================================= */

  var params =
    new URLSearchParams(
      window.location.search
    );


  var originalQuery =
    (
      params.get('q') || ''
    ).trim();


  if (!originalQuery) {

    return;

  }



  /* =========================================================
     NORMALIZE TEXT
  =========================================================

     SST-073 → SST073
     SST 073 → SST073
     SST_073 → SST073

     M-S016  → MS016
     MS-016  → MS016

     SK-003-B → SK003B
  ========================================================= */

  function normalizeText(value) {

    if (!value) {

      return '';

    }


    return String(value)
      .normalize('NFKC')
      .toLocaleUpperCase()
      .replace(
        /[^\p{L}\p{N}]+/gu,
        ''
      );

  }



  /* =========================================================
     DETECT MODEL NUMBER
  =========================================================

     必须同时包含：
     - 字母
     - 数字

     普通文字不进入自定义索引。
  ========================================================= */

  function isModelQuery(value) {

    if (!value) {

      return false;

    }


    var text =
      String(value).trim();


    if (!text) {

      return false;

    }


    /*
     * Must contain a letter.
     */

    if (!/[A-Za-z]/.test(text)) {

      return false;

    }


    /*
     * Must contain a number.
     */

    if (!/[0-9]/.test(text)) {

      return false;

    }


    /*
     * Model codes normally only contain
     * letters, numbers and separators.
     */

    if (
      !/^[A-Za-z0-9\s._\-\/]+$/.test(text)
    ) {

      return false;

    }


    var compact =
      normalizeText(text);


    /*
     * Avoid tiny useless searches.
     */

    if (compact.length < 3) {

      return false;

    }


    /*
     * Avoid treating long normal phrases
     * as product codes.
     */

    if (compact.length > 24) {

      return false;

    }


    return true;

  }



  /* =========================================================
     IMPORTANT
     NORMAL TEXT → SHOPIFY SEARCH
  ========================================================= */

  if (!isModelQuery(originalQuery)) {

    /*
     * Stop here.
     *
     * Existing Shopify search results remain untouched.
     */

    return;

  }



  /* =========================================================
     MODEL SEARCH STARTS HERE
  ========================================================= */

  var normalizedQuery =
    normalizeText(
      originalQuery
    );



  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHtml(value) {

    return String(
      value || ''
    )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }



  /* =========================================================
     SHOP ROOT
  ========================================================= */

  var shopRoot =
    (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    )
      ?
      Shopify.routes.root
      :
      '/';



  /* =========================================================
     MATCH SCORE
  ========================================================= */

  function getMatchScore(product) {

    if (
      !product ||
      !product.title
    ) {

      return 0;

    }


    var normalizedTitle =
      normalizeText(
        product.title
      );


    if (!normalizedTitle) {

      return 0;

    }



    /*
     * Exact normalized title.
     */

    if (
      normalizedTitle ===
      normalizedQuery
    ) {

      return 1000;

    }



    /*
     * Main matching.
     *
     * SST073 finds SST-073
     * MS016 finds M-S016
     * SST07 finds SST-070 / 071 / 073...
     */

    if (
      normalizedTitle.includes(
        normalizedQuery
      )
    ) {

      var position =
        normalizedTitle.indexOf(
          normalizedQuery
        );


      return (
        800 -
        Math.min(
          position,
          150
        )
      );

    }


    return 0;

  }



  /* =========================================================
     CREATE SEARCH PAGE
  ========================================================= */

  var main =
    document.getElementById(
      'MainContent'
    );


  if (!main) {

    return;

  }


  main.innerHTML = `

    <section class="toyvix-custom-search">

      <div class="toyvix-search-inner">

        <div class="toyvix-search-label">
          TOYVIX SEARCH
        </div>


        <h1 class="toyvix-search-heading">
          Find your next grail
        </h1>


        <form
          class="toyvix-search-form"
          action="${shopRoot}search"
          method="get"
        >

          <input
            type="search"
            name="q"
            value="${escapeHtml(originalQuery)}"
            placeholder="Search products"
            autocomplete="off"
            aria-label="Search products"
          >


          <button type="submit">
            SEARCH
          </button>

        </form>


        <div
          id="ToyvixSearchStatus"
          class="toyvix-search-status"
        >
          Searching...
        </div>


        <div
          id="ToyvixSearchResults"
          class="toyvix-search-grid"
        ></div>

      </div>

    </section>

  `;



  /* =========================================================
     SEARCH CSS
  ========================================================= */

  var style =
    document.createElement(
      'style'
    );


  style.textContent = `

    .toyvix-custom-search {
      min-height: 600px;
      padding: 90px 0 100px;
      background:
        var(--bg, #090909);
      color:
        var(--text, #f5f3ef);
    }


    .toyvix-search-inner {
      width:
        min(
          1440px,
          calc(100% - 80px)
        );
      margin: 0 auto;
    }


    .toyvix-search-label {
      margin-bottom: 18px;
      color:
        var(--accent, #c9a45c);
      font-size: 14px;
      font-weight: 700;
      letter-spacing: .16em;
    }


    .toyvix-search-heading {
      margin: 0 0 34px;
      font-size:
        clamp(
          38px,
          4vw,
          58px
        );
      line-height: 1.05;
    }


    .toyvix-search-form {
      display: flex;
      width:
        min(
          900px,
          100%
        );
      margin-bottom: 30px;
    }


    .toyvix-search-form input {
      flex: 1;
      min-width: 0;
      height: 64px;
      padding: 0 22px;
      border:
        1px solid #343434;
      border-radius: 0;
      outline: 0;
      background: #111;
      color: #fff;
      font-size: 17px;
    }


    .toyvix-search-form input:focus {
      border-color:
        var(--accent, #c9a45c);
    }


    .toyvix-search-form button {
      width: 150px;
      height: 64px;
      margin-left: 12px;
      border: 0;
      background:
        var(--accent, #c9a45c);
      color: #0b0b0b;
      font-size: 15px;
      font-weight: 800;
      letter-spacing: .08em;
      cursor: pointer;
    }


    .toyvix-search-status {
      margin: 0 0 30px;
      color:
        var(--muted, #aaa8a3);
      font-size: 16px;
    }


    .toyvix-search-grid {
      display: grid;
      grid-template-columns:
        repeat(
          4,
          minmax(0, 1fr)
        );
      gap: 36px 22px;
    }


    .toyvix-search-card {
      min-width: 0;
    }


    .toyvix-search-image-wrap {
      position: relative;
      display: block;
      overflow: hidden;
      aspect-ratio: 1 / 1;
      background: #141414;
    }


    .toyvix-search-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition:
        transform .3s ease;
    }


    .toyvix-search-card:hover
    .toyvix-search-image {

      transform:
        scale(1.025);

    }


    .toyvix-search-soldout {
      position: absolute;
      top: 12px;
      left: 12px;
      padding: 7px 10px;
      background: #111;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
    }


    .toyvix-search-card-body {
      padding-top: 15px;
    }


    .toyvix-search-vendor {
      margin-bottom: 6px;
      color:
        var(--accent, #c9a45c);
      font-size: 11px;
      font-weight: 700;
      letter-spacing: .1em;
      text-transform: uppercase;
    }


    .toyvix-search-product-title {
      margin: 0;
      font-size: 15px;
      line-height: 1.45;
      font-weight: 600;
    }


    .toyvix-search-product-title a {
      color:
        var(--text, #f5f3ef);
      text-decoration: none;
    }


    .toyvix-search-price {
      margin-top: 9px;
      font-size: 14px;
      font-weight: 700;
    }


    .toyvix-search-empty {
      grid-column: 1 / -1;
      padding: 30px 0;
      color:
        var(--muted, #aaa8a3);
      font-size: 18px;
    }


    @media screen and
    (max-width: 1100px) {

      .toyvix-search-grid {
        grid-template-columns:
          repeat(
            3,
            minmax(0, 1fr)
          );
      }

    }


    @media screen and
    (max-width: 760px) {

      .toyvix-custom-search {
        padding: 55px 0 70px;
      }


      .toyvix-search-inner {
        width:
          calc(100% - 32px);
      }


      .toyvix-search-heading {
        font-size: 36px;
      }


      .toyvix-search-form {
        display: grid;
        grid-template-columns:
          1fr auto;
      }


      .toyvix-search-form button {
        width: 105px;
        margin-left: 8px;
      }


      .toyvix-search-grid {
        grid-template-columns:
          repeat(
            2,
            minmax(0, 1fr)
          );
        gap: 28px 14px;
      }

    }

  `;


  document.head.appendChild(
    style
  );



  /* =========================================================
     CACHE
  ========================================================= */

  function readCache() {

    try {

      var savedTime =
        Number(
          sessionStorage.getItem(
            CACHE_TIME_KEY
          ) || 0
        );


      if (!savedTime) {

        return null;

      }


      var age =
        Date.now() -
        savedTime;


      if (age > CACHE_TTL) {

        sessionStorage.removeItem(
          CACHE_KEY
        );

        sessionStorage.removeItem(
          CACHE_TIME_KEY
        );

        return null;

      }


      var data =
        sessionStorage.getItem(
          CACHE_KEY
        );


      if (!data) {

        return null;

      }


      var parsed =
        JSON.parse(data);


      if (!Array.isArray(parsed)) {

        return null;

      }


      return parsed;

    } catch (error) {

      return null;

    }

  }



  function writeCache(products) {

    try {

      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify(products)
      );


      sessionStorage.setItem(
        CACHE_TIME_KEY,
        String(Date.now())
      );

    } catch (error) {

      /*
       * Browser storage full or disabled.
       * Search still works without cache.
       */

    }

  }



  /* =========================================================
     PARSE INDEX HTML
  ========================================================= */

  function parseIndexHtml(html) {

    var parser =
      new DOMParser();


    var documentData =
      parser.parseFromString(
        html,
        'text/html'
      );


    var indexElement =
      documentData.querySelector(
        '#ToyvixProductIndex'
      );


    if (!indexElement) {

      throw new Error(
        'Toyvix product index not found.'
      );

    }


    var sectionElement =
      indexElement.closest(
        '.shopify-section'
      );


    var sectionId =
      null;


    if (
      sectionElement &&
      sectionElement.id &&
      sectionElement.id.indexOf(
        'shopify-section-'
      ) === 0
    ) {

      sectionId =
        sectionElement.id.replace(
          'shopify-section-',
          ''
        );

    }


    var data =
      JSON.parse(
        indexElement.textContent
      );


    return {
      data: data,
      sectionId: sectionId
    };

  }



  /* =========================================================
     FULL FIRST PAGE
  ========================================================= */

  function buildFullIndexUrl(page) {

    return (
      shopRoot +
      'collections/all' +
      '?view=search-index' +
      '&page=' +
      page
    );

  }



  async function fetchFullIndexPage(page) {

    var response =
      await fetch(
        buildFullIndexUrl(page),
        {
          credentials:
            'same-origin'
        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to load product index.'
      );

    }


    var html =
      await response.text();


    return parseIndexHtml(
      html
    );

  }



  /* =========================================================
     SECTION RENDERING API
  ========================================================= */

  function buildSectionUrl(
    page,
    sectionId
  ) {

    return (
      shopRoot +
      'collections/all' +
      '?view=search-index' +
      '&page=' +
      page +
      '&section_id=' +
      encodeURIComponent(
        sectionId
      )
    );

  }



  async function fetchSectionIndexPage(
    page,
    sectionId
  ) {

    var response =
      await fetch(
        buildSectionUrl(
          page,
          sectionId
        ),
        {
          credentials:
            'same-origin'
        }
      );


    if (!response.ok) {

      throw new Error(
        'Section index request failed.'
      );

    }


    var html =
      await response.text();


    /*
     * Section Rendering API returns the
     * section HTML directly.
     */

    var parser =
      new DOMParser();


    var documentData =
      parser.parseFromString(
        html,
        'text/html'
      );


    var indexElement =
      documentData.querySelector(
        '#ToyvixProductIndex'
      );


    if (!indexElement) {

      throw new Error(
        'Section product index not found.'
      );

    }


    return JSON.parse(
      indexElement.textContent
    );

  }



  /* =========================================================
     LOAD ALL PRODUCTS
  ========================================================= */

  async function loadAllProducts() {

    /*
     * ---------------------------------------
     * 1. CACHE FIRST
     * ---------------------------------------
     */

    var cached =
      readCache();


    if (cached) {

      return {
        products: cached,
        cached: true
      };

    }



    /*
     * ---------------------------------------
     * 2. FIRST PAGE
     * ---------------------------------------
     *
     * First page discovers:
     *
     * - product data
     * - number of pages
     * - dynamic Shopify section ID
     */

    var firstResult =
      await fetchFullIndexPage(1);


    var firstPage =
      firstResult.data;


    var sectionId =
      firstResult.sectionId;



    if (sectionId) {

      try {

        sessionStorage.setItem(
          SECTION_ID_KEY,
          sectionId
        );

      } catch (error) {}

    }



    var products =
      Array.isArray(
        firstPage.products
      )
        ?
        firstPage.products
        :
        [];


    var totalPages =
      Number(
        firstPage.pages || 1
      );



    if (totalPages <= 1) {

      writeCache(products);


      return {
        products: products,
        cached: false
      };

    }



    /*
     * ---------------------------------------
     * 3. LOAD REMAINING PAGES
     * ---------------------------------------
     */

    var requests = [];


    for (
      var page = 2;
      page <= totalPages;
      page++
    ) {


      /*
       * If Shopify section ID was found,
       * download only the search-index section.
       *
       * Otherwise fall back to full HTML.
       */

      if (sectionId) {

        requests.push(

          fetchSectionIndexPage(
            page,
            sectionId
          )
            .catch(function () {

              return null;

            })

        );

      } else {

        requests.push(

          fetchFullIndexPage(page)
            .then(function (result) {

              return result.data;

            })

        );

      }

    }



    var results =
      await Promise.all(
        requests
      );



    /*
     * If Section Rendering API failed for
     * any page, fetch that page normally.
     */

    for (
      var i = 0;
      i < results.length;
      i++
    ) {

      var pageNumber =
        i + 2;


      var data =
        results[i];


      if (!data) {

        var fallback =
          await fetchFullIndexPage(
            pageNumber
          );


        data =
          fallback.data;

      }


      if (
        data &&
        Array.isArray(
          data.products
        )
      ) {

        products =
          products.concat(
            data.products
          );

      }

    }



    /*
     * ---------------------------------------
     * 4. CACHE
     * ---------------------------------------
     */

    writeCache(
      products
    );


    return {
      products: products,
      cached: false
    };

  }



  /* =========================================================
     RENDER RESULTS
  ========================================================= */

  function renderProducts(
    products
  ) {

    var status =
      document.getElementById(
        'ToyvixSearchStatus'
      );


    var container =
      document.getElementById(
        'ToyvixSearchResults'
      );


    if (
      !status ||
      !container
    ) {

      return;

    }



    var matches =
      products

        .map(function (
          product,
          index
        ) {

          return {

            product:
              product,

            score:
              getMatchScore(
                product
              ),

            index:
              index

          };

        })


        .filter(function (item) {

          return (
            item.score > 0
          );

        })


        .sort(function (a, b) {

          if (
            b.score !==
            a.score
          ) {

            return (
              b.score -
              a.score
            );

          }


          return (
            a.index -
            b.index
          );

        });



    status.textContent =
      matches.length +
      (
        matches.length === 1
          ?
          ' result for “'
          :
          ' results for “'
      ) +
      originalQuery +
      '”';



    if (!matches.length) {

      container.innerHTML =
        '<div class="toyvix-search-empty">' +
        'No products found.' +
        '</div>';


      return;

    }



    container.innerHTML =
      matches
        .map(function (item) {

          var product =
            item.product;


          var imageHtml =
            '';


          if (product.image) {

            imageHtml =
              '<img ' +
              'class="toyvix-search-image" ' +
              'src="' +
              escapeHtml(
                product.image
              ) +
              '" ' +
              'alt="' +
              escapeHtml(
                product.title
              ) +
              '" ' +
              'loading="lazy">';

          }



          var soldOutHtml =
            '';


          if (
            product.available ===
            false
          ) {

            soldOutHtml =
              '<span ' +
              'class="toyvix-search-soldout">' +
              'SOLD OUT' +
              '</span>';

          }



          var vendorHtml =
            '';


          if (product.vendor) {

            vendorHtml =
              '<div ' +
              'class="toyvix-search-vendor">' +
              escapeHtml(
                product.vendor
              ) +
              '</div>';

          }



          return (

            '<article ' +
            'class="toyvix-search-card">' +


              '<a ' +
              'class="toyvix-search-image-wrap" ' +
              'href="' +
              escapeHtml(
                product.url
              ) +
              '">' +


                imageHtml +


                soldOutHtml +


              '</a>' +


              '<div ' +
              'class="toyvix-search-card-body">' +


                vendorHtml +


                '<h2 ' +
                'class="toyvix-search-product-title">' +


                  '<a href="' +
                  escapeHtml(
                    product.url
                  ) +
                  '">' +


                    escapeHtml(
                      product.title
                    ) +


                  '</a>' +


                '</h2>' +


                '<div ' +
                'class="toyvix-search-price">' +


                  escapeHtml(
                    product.price
                  ) +


                '</div>' +


              '</div>' +


            '</article>'

          );

        })

        .join('');

  }



  /* =========================================================
     RUN
  ========================================================= */

  loadAllProducts()

    .then(function (result) {

      renderProducts(
        result.products
      );

    })


    .catch(function (error) {

      console.error(
        '[Toyvix Fast Search]',
        error
      );


      var status =
        document.getElementById(
          'ToyvixSearchStatus'
        );


      var container =
        document.getElementById(
          'ToyvixSearchResults'
        );


      if (status) {

        status.textContent =
          'Search unavailable.';

      }


      if (container) {

        container.innerHTML =
          '<div class="toyvix-search-empty">' +
          'Unable to load products. Please try again.' +
          '</div>';

      }

    });

});